/**
 * duplicate-owner-prefill - map a matched duplicate property's owner onto the
 * Customer Details step (WPS-38).
 *
 * When a registration continues against an EXISTING property - either merging
 * into an existing record or adding a new product to it - the operator should
 * not have to retype the property owner's details. The duplicate-address match
 * already carries the current owner (email + split name + phone), so we pre-fill
 * the wizard's consumer fields from it.
 *
 * Prefill is intentionally NON-DESTRUCTIVE: only fields the operator has left
 * empty are filled, so their own edits are never overwritten (mirrors the
 * "existing customer" email-lookup prefill in step-customer.tsx).
 */

export interface DuplicateOwnerSource {
  owner_email?: string | null
  owner_first_name?: string | null
  owner_last_name?: string | null
  owner_phone?: string | null
}

export interface ConsumerFieldSnapshot {
  consumerEmail: string
  consumerFirstName: string
  consumerLastName: string
  consumerPhone: string
}

export type ConsumerPrefill = Partial<ConsumerFieldSnapshot>

export function consumerPrefillFromMatch(
  match: DuplicateOwnerSource | null | undefined,
  current: ConsumerFieldSnapshot,
): ConsumerPrefill {
  if (!match) return {}
  const payload: ConsumerPrefill = {}
  if (!current.consumerEmail && match.owner_email) {
    payload.consumerEmail = match.owner_email
  }
  if (!current.consumerFirstName && match.owner_first_name) {
    payload.consumerFirstName = match.owner_first_name
  }
  if (!current.consumerLastName && match.owner_last_name) {
    payload.consumerLastName = match.owner_last_name
  }
  if (!current.consumerPhone && match.owner_phone) {
    payload.consumerPhone = match.owner_phone
  }
  return payload
}
